<template>
  <div class="result-overlay" @click.self="$emit('close')">
    <div class="auth-dialog">
      <button class="dialog-close" @click="$emit('close')">×</button>
      <div class="brand auth-brand"><span class="brand-mark"><i></i><i></i></span><span>calm<span>decide</span></span></div>
      <h2>{{ mode === 'login' ? 'Welcome back.' : 'Keep your choices close.' }}</h2>
      <p>{{ mode === 'login' ? 'Your decision journal is waiting.' : 'Create a private place to save and revisit decisions.' }}</p>
      <form @submit.prevent="submit">
        <label v-if="mode === 'register'">YOUR NAME<input v-model.trim="form.name" required maxlength="80" autocomplete="name" placeholder="How should we call you?"></label>
        <label>EMAIL<input v-model.trim="form.email" type="email" required autocomplete="email" placeholder="you@example.com"></label>
        <label>PASSWORD<input v-model="form.password" type="password" required minlength="8" autocomplete="current-password" placeholder="At least 8 characters"></label>
        <span v-if="error" class="form-error">{{ error }}</span>
        <button class="primary-button" :disabled="loading">{{ loading ? 'One moment…' : mode === 'login' ? 'Sign in' : 'Create account' }}</button>
      </form>
      <button class="auth-switch" @click="switchMode">{{ mode === 'login' ? 'New here? Create an account' : 'Already have an account? Sign in' }}</button>
    </div>
  </div>
</template>

<script>
import { api, saveSession } from '../services/api'

export default {
  name: 'AuthModal',
  data: () => ({ mode: 'login', form: { name: '', email: '', password: '' }, loading: false, error: '' }),
  methods: {
    switchMode () { this.mode = this.mode === 'login' ? 'register' : 'login'; this.error = '' },
    async submit () {
      this.loading = true; this.error = ''
      try {
        const data = this.mode === 'login' ? await api.login(this.form) : await api.register(this.form)
        saveSession(data)
        this.$emit('authenticated', data.user)
      } catch (error) { this.error = error.message } finally { this.loading = false }
    }
  }
}
</script>
